import Headline from './Index.vue'

Headline.install = function(Vue) {
  Vue.component(Headline.name, Headline)
}

export default Headline
